import { supabase } from "@/lib/supabase";

export async function uploadToBucket(opts: {
  bucket: string;
  path: string; // e.g. `shops/<shopId>/logo.png`
  file: File;
}) {
  const { bucket, path, file } = opts;
  const { error: upErr } = await supabase.storage.from(bucket).upload(path, file, {
    cacheControl: "3600",
    upsert: true,
  });
  if (upErr) throw upErr;
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl as string;
}
